import { create } from 'zustand';
import type { LeaveRequestStatus } from '../api/leave.api';

// ─── Types ────────────────────────────────────────────────────────────────────

export type LeaveTab = 'my_leaves' | 'approvals';
export type StatusFilter = LeaveRequestStatus | 'all';

// ─── Store ────────────────────────────────────────────────────────────────────

interface LeaveRequestState {
  // My Leaves tab
  myLeavesPage: number;
  setMyLeavesPage: (page: number) => void;
  myLeavesPageSize: number;
  myLeavesTotal: number;
  setMyLeavesTotal: (total: number) => void;
  myLeavesStatus: StatusFilter;
  setMyLeavesStatus: (status: StatusFilter) => void;

  // Approvals tab
  approvalsPage: number;
  setApprovalsPage: (page: number) => void;
  approvalsPageSize: number;
  approvalsTotal: number;
  setApprovalsTotal: (total: number) => void;
  approvalsStatus: StatusFilter;
  setApprovalsStatus: (status: StatusFilter) => void;

  // Pending count for badge
  pendingApprovalCount: number;
  setPendingApprovalCount: (count: number) => void;
}

export const useLeaveRequestStore = create<LeaveRequestState>((set) => ({
  // My Leaves — default: show all statuses, page 1
  myLeavesPage: 1,
  setMyLeavesPage: (myLeavesPage) => set({ myLeavesPage }),
  myLeavesPageSize: 25,
  myLeavesTotal: 0,
  setMyLeavesTotal: (myLeavesTotal) => set({ myLeavesTotal }),
  myLeavesStatus: 'all',
  setMyLeavesStatus: (myLeavesStatus) =>
    set({ myLeavesStatus, myLeavesPage: 1 }),

  // Approvals — default: show pending, page 1
  approvalsPage: 1,
  setApprovalsPage: (approvalsPage) => set({ approvalsPage }),
  approvalsPageSize: 25,
  approvalsTotal: 0,
  setApprovalsTotal: (approvalsTotal) => set({ approvalsTotal }),
  approvalsStatus: 'pending',
  setApprovalsStatus: (approvalsStatus) =>
    set({ approvalsStatus, approvalsPage: 1 }),

  // Badge
  pendingApprovalCount: 0,
  setPendingApprovalCount: (pendingApprovalCount) =>
    set({ pendingApprovalCount }),
}));
